import React, { useEffect, useState } from 'react';
import { balanceService } from '../../services/control/balance.service';
import swal from "sweetalert";
import { useSelector } from "react-redux";

import './balance.scss';

export function SearchBalance(props) {
    const countrySetting = useSelector(state => state.countrySetting);
    const [balanceData, setBalanceData] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;

    const getBalanceAll = () => {
        balanceService.getBalanceAll().then((result) => {
            if (result) {
                setBalanceData(result);
            }
        });
    }

    useEffect(() => {
        getBalanceAll();
    }, []);

    const handleSearch = (e) => {
        setSearch(e.target.value);
        setCurrentPage(1);
    };

    const onClickAction = (id, status) => {
        balanceService.alertPassword(status === 2 ? "Autorización" : "Rechazo").then(result => {
            if (result) {
                balanceService.edit({ balanceId: id, balanceStatusId: status, password: result })
                    .then(result => { if (result) getBalanceAll() });
            }
            else swal("No se ingresó contraseña", "Favor de ingresar su contraseña para realizar la acción.", "error");
        });
    };

    const downloadVoucherImage = (data) => {
        fetch(data)
            .then(response => response.blob())
            .then(function(myBlob) {
                const url = window.URL.createObjectURL(new Blob([myBlob]));
                const link = document.createElement('a');
                const extension = data.split('.').pop(); 
                link.href = url;
                link.setAttribute('download', `Comprobante.${extension}`);
                document.body.appendChild(link);
                link.click();
            });
    };

    // Filtro de búsqueda
    const filteredData = balanceData.filter(item =>
        item.companyReceiveName?.toLowerCase().includes(search.toLowerCase()) ||
        item.folio?.toLowerCase().includes(search.toLowerCase()) ||
        item.createDate?.toLowerCase().includes(search.toLowerCase()) ||
        item.reference?.toLowerCase().includes(search.toLowerCase())
    );

    // Paginación
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const changePage = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    return (
        <div className="table-responsive">
            <div className="mb-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar por Intermediario, Folio, Fecha de creación o Referencia"
                    value={search}
                    onChange={handleSearch}
                />
            </div>

            <table className="wrapper_table table table-sm table-hover">
                <thead>
                    <tr>
                        <th className="text fnt_medium">ID Traspaso</th>
                        <th className="text fnt_medium">Método de Pago</th>
                        <th className="text fnt_medium">Método de Negociación</th>
                        <th className="text fnt_medium">Saldo</th>
                        <th className="text fnt_medium">Intermediario / Compañía</th>
                        <th className="text fnt_medium">Usuario Final</th>
                        <th className="text fnt_medium">Folio</th>
                        <th className="text fnt_medium">Fecha de Creación</th>
                        <th className="text fnt_medium">Referencia</th>
                        <th className="text fnt_medium">Comprobante</th>
                        <th className="text fnt_medium">Estatus</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        paginatedData.map(balance => (
                            <tr key={balance.balanceId}>
                                <td>{balance.balanceId}</td>
                                <td>{balance.paymentTypeName}</td>
                                <td>{balance.tradingMethodName}</td>
                                <td>{countrySetting.currency}{Number(balance.balanceAmount).toLocaleString(countrySetting.cultureCode, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                <td>{balance.companyReceiveName ?? ''}</td>
                                <td>{balance.userReceiveName ?? ''}</td>
                                <td>{balance.folio ?? ''}</td>
                                <td>{balance.createDate}</td>
                                <td>{balance.reference}</td>
                                <td>
                                    {
                                        balance.voucherImage
                                            ? <button onClick={() => downloadVoucherImage(balance.voucherImage)} className="btn btn-sm btn-info">
                                                Descargar <i className="fas fa-download"></i>
                                            </button>
                                            : ''
                                    }
                                </td>
                                <td>
                                    {balance.balanceStatusId === 1 && balance.editable
                                        ? <span>
                                            <span className="option text-success" onClick={() => onClickAction(balance.balanceId, 2)}>
                                                <i className="fas fa-check-circle"> Autorizar</i>
                                            </span>
                                            <br />
                                            <span className="option text-danger" onClick={() => onClickAction(balance.balanceId, 3)}>
                                                <i className="fas fa-times-circle"> Rechazar</i>
                                            </span>
                                        </span>
                                        : <span className="icon_tables">{balance.balanceStatusName}</span>
                                    }
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>

            {/* Paginación */}
            <div className="d-flex justify-content-between align-items-center mt-3">
                <button className="btn btn-outline-secondary btn-sm" onClick={() => changePage(currentPage - 1)} disabled={currentPage === 1}>
                    Anterior
                </button>
                <span>Página {currentPage} de {totalPages}</span>
                <button className="btn btn-outline-secondary btn-sm" onClick={() => changePage(currentPage + 1)} disabled={currentPage === totalPages}>
                    Siguiente
                </button>
            </div>
        </div>
    );
}
